import { siteConfig } from "./common/site";
import { homePageData } from "./pages/home";

export const siteContent = {
  header: {
    logo: siteConfig.logos,
    cta: siteConfig.cta,
  },
  ...homePageData,
};

export * from "./common/site";
export * from "./common/navigation";
export * from "./pages/home";
